import { Dropdown as PrimereactDropdown } from 'primereact/dropdown';
import {ReactComponent as ArrowDown} from '../../assets/images/arrow_down.svg';
import {ReactComponent as ArrowUp} from '../../assets/images/arrow_up.svg';
import { classNames } from 'primereact/utils';
import { ReactComponent as ValidationErrorIcon } from '../../assets/images/validation-error.svg';

const Dropdown = ({showLabel = true, label, small = false, validator, validations, ...rest}) => {
    const id = `dropdown-${rest.id}`;
    const validationMessage = validator ? validator.message(id, label, rest.value, validations) : null;
    
    return (
        <div className={classNames('field', rest.className)}>
            {showLabel && <label htmlFor={id}>{label}</label>}
            <PrimereactDropdown {...rest} id={id} className={classNames('w-full', {'small': small, 'p-invalid': validationMessage})} 
                dropdownIcon={<ArrowDown />} collapseIcon={<ArrowUp/>}
                panelClassName={small ? 'small' : ''}
            />
            {validationMessage && <div className={"validation-error"}>
                <ValidationErrorIcon className='icon'/>
                <div className="text">{validationMessage}</div>
            </div>}
        </div>
    )
}

export default Dropdown;